export const origins = [
  { label: 'Kraj', value: 'kraj' },
  { label: 'Import', value: 'import' }
]



// WEBPACK FOOTER //
// ./src/helpers.js